import { addNewColor } from '../../dist/encryption/addNewColor.esm'
import { getLabelText } from '../utils'
import SparkMD5 from 'spark-md5'
let timer = null
const lawUrlArray = ['/auth/merc/login']
const uploadUrls = [
  '/system/oss/upload',
  '/system/oss/identifier/upload',
  '/system/wx/sysWxAutoReply/addImages',
  '/system/oss/upload4Jpg',
  '/business/manage/workOrder/uploadAndVerifyFile',
  '/business/admin/aliExpressServiceItem/checkLzAsinFile',
  '/business/moonshot/ai/match/single'
]

function addUploadHeaders(config) {
  const requestUrl = config.url?.startsWith('/') ? config.url : `/${config.url}`
  if (!uploadUrls.some((url) => requestUrl.includes(url))) {
    return config
  }
  if (!(config.data instanceof FormData)) {
    return config
  }
  const file = config.data.get('file') || config.data.get('multipartFile')
  if (!file) {
    return config
  }
  config.headers['fileSize'] = file.size
  return config
}
function getCookie(name) {
  const cookieString = document.cookie
  const cookies = cookieString.split('; ')

  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=')
    if (cookieName === name) {
      return decodeURIComponent(cookieValue)
    }
  }
  return null
}
function getCurrentRoutePath(router) {
  const appInstance = typeof app !== 'undefined' ? app : null
  const route = router?.$route || router?.currentRoute || router?.history?.current || appInstance?.$route || appInstance?._route
  return route?.path || window.location.pathname || ''
}

const err = (error, loading_gdzt, message, cookies, ACCESS_TOKEN, store, funcUrlDel, platType, POST_MSG_TYPE) => {
  if (platType === 'admin') {
    loading_gdzt.destroy()
  }
  if (error.response) {
    if (error.response.status === 403) {
      message.error(getLabelText({ key: 'remote.common.youDotPermission', text: '你没有权限' }))
    }
    if (error.response.status === 429) {
      message.error(getLabelText({ key: 'remote.common.yritfptal', text: '您的请求太过频繁,请稍后再试' }))
    }
    if (error.response.status === 500) {
      message.error(getLabelText({ key: 'remote.common.systemBusy', text: '系统开小差了' }))
    }
    if (error.response.status === 408) {
      window.location.href = '/error.html'
      return
    }
    if (platType === 'merchant') {
      if (error.response.status === 401) {
        if (error.response.data?.code !== 523) {
          message.error(getLabelText({ key: 'remote.common.loginFailedAg', text: '登录失效，请重新登录' }))
        }
        app.$ls.set(ACCESS_TOKEN, '')
        window?.localStorage.removeItem('openScoreModel')
        window?.localStorage.setItem('waitHandleLetter', '')
        if (store.state.isProxyOrder) {
          // 代客户加购，401，admin退回到上一级路由
          window?.parent.postMessage({ type: POST_MSG_TYPE.PROXY_ORDER_LOGOUT }, '*')
          return
        }

        const h = window?.location.href
        let d = process.env.NODE_ENV === 'development' ? document.domain : document.domain.split('.').slice(-2).join('.')
        document.cookie = `loginCode='';path=/;domain=${d}`
        //  store.state.loginType=true;
        // 避免两次loading
        const notReloadList = ['/activityOverview']

        if (error?.config?.url === '/system/user/info' && notReloadList.some((item) => location?.pathname?.includes(item))) {
          return Promise.reject(error)
        }
        if (error.response.data?.code === 523) {
          // 黑名单用户提示语句
          store.state.stopUserOperation = 4
          setTimeout(() => {
            window?.location.reload()
          }, 3000)
          return
        } else {
          // 普通商户登录失效后刷新当前窗口，进入既有登录恢复流程。
          window?.location.reload()
        }
      }
      if (error.response.status === 412) {
        message.error('The service is Lost')
      }
    } else {
      if (error.response.status === 401 || error.response.data?.code === 401) {
        if (timer) {
          clearTimeout(timer)
          timer = setTimeout(() => {
            message.error(getLabelText({ key: 'remote.common.dtpiylhbiplia', text: '因长时间无操作，您的登录失效了，请重新登陆' }))
          }, 500)
        } else {
          timer = setTimeout(() => {
            message.error(getLabelText({ key: 'remote.common.dtpiylhbiplia', text: '因长时间无操作，您的登录失效了，请重新登陆' }))
          }, 500)
        }
        cookies.remove(ACCESS_TOKEN)
        // 删除产品标签评分标识
        localStorage.removeItem('openScoreModel')
        store.state.loginType = true
        let backUrl = funcUrlDel('token')
        backUrl = funcUrlDel('platform', backUrl)
      }

      if (error.response.status === 404) {
        console.log('接口找不到')
      }
    }
  }
  return Promise.reject(error)
}
const quanxian = (config, store, PRIVATE_CONTROL_NAME, COUNTRY_CONTROL_NAME, whiteList, platType, router, message) => {
  const privateMenus = store.state.user.privateMenus?.length ? store.state.user.privateMenus.concat(PRIVATE_CONTROL_NAME) : [] // 私有数据
  const countryMenus = store.state.user.countryMenus?.length ? store.state.user.countryMenus.concat(COUNTRY_CONTROL_NAME) : [] // 国家数据
  const dataOperation = store.state.user.info.dataOperation // 数据权限

  let privateFlag = false
  let countryFlag = false
  const pathNameArr = getCurrentRoutePath(router).split('/')
  pathNameArr.forEach((name) => {
    const _private = privateMenus.includes(name)
    const _country = countryMenus.includes(name)
    if (!privateFlag) {
      privateFlag = _private
    }
    if (!countryFlag) {
      countryFlag = _country
    }
  })
  // 操作数据权限判断
  const info = store.state.user.info
  if (info && info.userId !== -1) {
    // 过滤admin
    if (privateFlag && countryFlag) {
      // 两者都有
      if (config.method == 'post' && !whiteList.includes(config.url)) {
        // 编辑
        if (dataOperation == '3') {
          // 拥有自己和下级的编辑权限
        } else if (dataOperation == '0') {
          // 仅编辑自己的权限
          const customerId =
            config.url.indexOf('/mcTaxApply/updateDistributeCustomerService') !== -1
              ? config.data.ownerCustomerId
              : config.data
              ? config.data.customerId
              : config.params
              ? config.params.customerId
              : ''

          if (customerId != info.userId) {
            message.error(getLabelText({ key: 'remote.common.youDon.tHavePermissionToOperate', text: '你没有操作权限' }))
            return Promise.reject(new Error({ msg: '403' }))
          }
        } else {
          // 没有编辑权限
          message.error(getLabelText({ key: 'remote.common.youDon.tHavePermissionToOperate', text: '你没有操作权限' }))
          return Promise.reject(new Error({ msg: '403' }))
        }
      }
      config.headers['requestSource'] = '11'
    } else if (privateFlag && !countryFlag) {
      // 私有有、国家没有
      if (config.method == 'post' && !whiteList.includes(config.url)) {
        // 编辑
        if (dataOperation == '3') {
          // 拥有自己和下级的编辑权限
        } else if (dataOperation == '0') {
          // 仅编辑自己的权限
          const customerId =
            config.url.indexOf('/mcTaxApply/updateDistributeCustomerService') !== -1
              ? config.data.ownerCustomerId
              : config.data
              ? config.data.customerId
              : config.params
              ? config.params.customerId
              : ''
          if (customerId && customerId != info.userId) {
            message.error(getLabelText({ key: 'remote.common.youDon.tHavePermissionToOperate', text: '你没有操作权限' }))
            return Promise.reject(new Error({ msg: '403' }))
          }
        } else {
          // 没有编辑权限
          message.error(getLabelText({ key: 'remote.common.youDon.tHavePermissionToOperate', text: '你没有操作权限' }))
          return Promise.reject(new Error({ msg: '403' }))
        }
      }
      config.headers['requestSource'] = '10'
    } else if (!privateFlag && countryFlag) {
      // 国家有、私有没有
      config.headers['requestSource'] = '01'
    } else {
      // 两者都没有
      delete config.headers['requestSource']
    }
  }
}

function service(
  axios,
  baseURL,
  noLoadingApiList,
  loading_gdzt,
  SYSTEM_TYPE,
  platform,
  cookies,
  ACCESS_TOKEN,
  store,
  PRIVATE_CONTROL_NAME,
  COUNTRY_CONTROL_NAME,
  router = {},
  whiteList,
  message,
  funcUrlDel,
  platType,
  POST_MSG_TYPE
) {
  let service = axios.create({
    baseURL: baseURL, // api base_url
    timeout: 300000 // 请求超时时间
  })
  service.interceptors.request.use(
    (config) => {
      let token = null
      let stores = store
      let routers = router
      let platforms = platform
      if (platType == 'commonAdmin' || platType === 'merchant') {
        stores = app.$store
        routers = app
      }
      // IPP律师端登录接口
      if (platform == '01' && stores?.getters?.isLAW && lawUrlArray.includes(config.url)) {
        platforms = '04'
      }
      // 报表可在供应链中心容器内查询其他业务平台，显式范围优先于页面容器上下文。
      config.headers['current-systemtype'] = config.reportScope?.systemType || SYSTEM_TYPE
      config.headers['platform'] = config.reportScope?.platform || platforms
      config.headers['browserUrl'] = window.location.href
      if (['admin', 'commonAdmin'].includes(platType)) {
        config.headers['request-platform'] = '01'
      }
      if (['merchant', 'commonMerchant'].includes(platType)) {
        config.headers['request-platform'] = '00'
      }
      // IPP律师端特殊处理
      if (stores?.getters?.isLAW) {
        config.headers['request-platform'] = '01'
      }

      const requestLang = config.headers?.['Accept-Language'] || config.headers?.['accept-language'] || config.headers?.['Content-Language'] || config.headers?.['content-language']
      const lang = requestLang || window.app?.$store?.getters?.['lang']
      if (lang) {
        config.headers['Accept-Language'] = lang
        config.headers['Content-Language'] = lang
      }
      // modern-screenshot

      if (platType === 'merchant') {
        token = app.$ls.get(ACCESS_TOKEN) || getCookie('token')
        const isProxyOrder = stores.state.isProxyOrder
        config.headers['systemType'] = SYSTEM_TYPE
        if (stores.state.user.token && token && stores.state.user.token != token) {
          window?.location.reload()
        }
        config.headers['Timestamp'] = '3.22.22'
        if (isProxyOrder && token) {
          // 代客户加购
          config.headers['otherBuyToken'] = token // 只有配了白名单的接口才能调通
        } else if (token && !config.whiteApiStatus) {
          config.headers['token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
        }
        config.headers['platform-type'] = 'Web'
        config.headers['platform-name'] = encodeURIComponent('商户端')
        config.headers['title'] = encodeURIComponent(stores.state.toTitle)
        config.headers['source-title'] = encodeURIComponent(stores.state.fromTitle)
        // 添加申报页面时间戳，防止页面多开的场景
        if (stores.state.declare && stores.state.declare.declareTimeStamp && stores.state.declare.declareDetail && stores.state.declare.declareDetail.declareId) {
          config.headers['Ver-Multi-Info'] = `${stores.state.declare.declareDetail.declareId},${stores.state.declare.declareTimeStamp}`
        }
        if (stores.state.vatBatchDeclaration && stores.state.vatBatchDeclaration.batchDeclareTimeStamp && stores.state.vatBatchDeclaration.batchId) {
          config.headers['Ver-Multi-Batch-Info'] = `${stores.state.vatBatchDeclaration.batchId},${stores.state.vatBatchDeclaration.batchDeclareTimeStamp}`
        }
        // 体验算税所有的请求，添加请求头
        if (stores.state.declare && stores.state.declare.testCalVat) {
          config.headers['Test-Cal-Vat'] = stores.state.declare.testCalVat
        }
        if (stores.state.eprReport && stores.state.eprReport.declareTimeStamp && stores.state.eprReport.declareDetail && stores.state.eprReport.declareDetail.id) {
          config.headers['Ver-Multi-Info'] = `${stores.state.eprReport.declareDetail.id},${stores.state.eprReport.declareTimeStamp}`
        }
      } else {
        if (platType === 'admin' && config.method == 'post' && !noLoadingApiList.includes(config.url)) {
          loading_gdzt.loading()
        }
        token = cookies.get(ACCESS_TOKEN)
        config.headers['Timestamp'] = '2.21.01'
        if (!config.data?.SSO) {
          //认证中心登录接口不能传systemType
          let systemType = config.HEADERSYSTEMTYPE
          config.headers['systemType'] = systemType ? systemType : SYSTEM_TYPE
          if (config.HEADERPLATFORM) {
            config.headers['platform'] = config.HEADERPLATFORM
          }
          config.headers['current_system_type'] = config.headers['systemType']
        }
        if (stores.state.user.token && token && stores.state.user.token != token) {
          window?.location.reload()
        }
        // 添加申报页面时间戳，防止页面多开的场景
        if (stores.state.verMultiInfo.valueOf && stores.state.verMultiInfo.detail && stores.state.verMultiInfo.detail.infoId) {
          config.headers['Ver-Multi-Info'] = `${stores.state.verMultiInfo.detail.infoId},${stores.state.verMultiInfo.valueOf}`
        }
        // 管理端也需要多页面的拦截 加上路由的判断
        console.log(router.$route, router?.currentRoute?.name, router.name)
        if (stores.state.eprReport && stores.state.eprReport.declareTimeStamp && stores.state.eprReport.declareDetail && stores.state.eprReport.declareDetail.id) {
          config.headers['Ver-Multi-Info'] = `${stores.state.eprReport.declareDetail.id},${stores.state.eprReport.declareTimeStamp}`
        }
        if (token && !config.noToken) {
          // config.headers['token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
          if (!config.headers.otherBuyToken) {
            // 代客户加购，则不需要token
            config.headers['token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
          }
          if (platType !== 'merchant') {
            if (quanxian(config, stores, PRIVATE_CONTROL_NAME, COUNTRY_CONTROL_NAME, whiteList, platType, routers, message)) {
              return
            }
          }
        }
      }
      const uploadConfig = addUploadHeaders(config)
      return addNewColor(uploadConfig)
    },
    (error) => {
      let stores = store
      if (platType == 'commonAdmin' || platType === 'merchant') {
        stores = app.$store
      }
      return err(error, loading_gdzt, message, cookies, ACCESS_TOKEN, stores, funcUrlDel, platType, POST_MSG_TYPE)
    }
  )

  // response interceptor
  service.interceptors.response.use(
    (response) => {
      let stores = store
      if (platType == 'commonAdmin' || platType === 'merchant') {
        stores = app.$store
      }
      if (platType == 'merchant') {
        if (response.headers && response.headers['content-type']) {
          const arr = decodeURI(response.headers['content-type']).split('¿')
          stores.state.types = arr[1]
        }
        if ((response.data.code == 500 && response.data?.msg?.indexOf('非法操作警告') > -1) || response.data == 5100 || response.data.code == 5100) {
          stores.state.stopUserOperation = 1
          return
        } else if (response.data.code == 408) {
          window.location.href = '/error.html'
          return
        }
      } else {
        if (response.config.method == 'post' && !noLoadingApiList.includes(response.config.url) && platType === 'admin') {
          loading_gdzt.destroy()
        }
        if (response.headers && response.headers['content-disposition']) {
          stores.state.headerName = response.headers['content-disposition']
        }
        if (response.headers && response.headers['filetype']) {
          stores.state.filetype = response.headers['filetype']
        }
        if (response.data.code == 500 && response.data?.msg?.indexOf('404 NOT_FOUND "No matching handler"') > -1) {
          return {
            code: 0,
            data: [],
            rows: [],
            msg: '操作成功'
          }
        }
      }
      if (response.config.isUpload) {
        //asw前端上传类型
        return response
      }
      if (Object.prototype.toString.call(response.data) === '[object Blob]') {
        const fileName = response.headers?.['x-file-name']
        if (fileName) {
          response.data.fileName = decodeURIComponent(fileName)
        }
      }
      return response.data
    },
    (error) => {
      let stores = store
      if (platType == 'commonAdmin' || platType === 'merchant') {
        stores = app.$store
      }
      return err(error, loading_gdzt, message, cookies, ACCESS_TOKEN, stores, funcUrlDel, platType, POST_MSG_TYPE)
    }
  )
  return service
}

function installer(VueAxios, service) {
  return {
    vm: {},
    install(Vue) {
      Vue.use(VueAxios, service)
    }
  }
}

function pureAxios(
  axios,
  baseURL,
  ACCESS_TOKEN,
  SYSTEM_TYPE,
  platform,
  store,
  PRIVATE_CONTROL_NAME,
  COUNTRY_CONTROL_NAME,
  router,
  whiteList,
  loading_gdzt,
  message,
  cookies,
  funcUrlDel,
  platType,
  POST_MSG_TYPE
) {
  let pureAxios = axios.create({
    baseURL: baseURL, // api base_url
    timeout: 300000 // 请求超时时间
  })
  pureAxios.interceptors.request.use(
    (config) => {
      let token = null
      let stores = store
      let routers = router
      if (platType == 'commonAdmin' || platType === 'merchant') {
        stores = app.$store
        routers = app
      }
      if (['admin', 'commonAdmin'].includes(platType) && ['16', '17'].includes(platform)) {
        config.headers['ADMIN'] = '01'
      }
      if (['merchant', 'commonMerchant'].includes(platType) && ['16', '17'].includes(platform)) {
        config.headers['MERCHANT'] = '00'
      }
      if (platType === 'merchant') {
        if (!config.whiteApiStatus) {
          token = app.$ls.get(ACCESS_TOKEN)
        }
        config.headers['platform-type'] = 'Web'
        config.headers['platform-name'] = encodeURIComponent('商户端')
        config.headers['title'] = encodeURIComponent(stores.state.toTitle)
        config.headers['source-title'] = encodeURIComponent(stores.state.fromTitle)
      } else {
        token = cookies.get(ACCESS_TOKEN)
        config.headers['Timestamp'] = '2.21.01'
        config.headers['platform'] = platform
      }
      config.headers['current-systemtype'] = SYSTEM_TYPE
      config.headers['systemType'] = SYSTEM_TYPE
      config.headers['browserUrl'] = window.location.href
      if (token) {
        config.headers['token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
        if (platType !== 'merchant') {
          if (quanxian(config, stores, PRIVATE_CONTROL_NAME, COUNTRY_CONTROL_NAME, whiteList, platType, routers, message)) {
            return
          }
        }
      }
      const uploadConfig = addUploadHeaders(config)
      return addNewColor(uploadConfig)
    },
    (error) => {
      let stores = store
      if (platType == 'commonAdmin' || platType === 'merchant') {
        stores = app.$store
      }
      return err(error, loading_gdzt, message, cookies, ACCESS_TOKEN, stores, funcUrlDel, platType, POST_MSG_TYPE)
    }
  )
  return pureAxios
}

export { service, installer, pureAxios }



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/request/request.js